var codeblock_default = {
  "blockStyleSpacing": "RBjbN",
  "codeBlock": "_07R1u RBjbN",
  "renderedInTable": "x7svg"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
